import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1f8197c4"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  style: {
    "background-color": "#f5f5f5"
  }
};
var _hoisted_2 = {
  class: "phone_number_query"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    style: {
      "color": "#cccccc"
    }
  }, null, -1);
});

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", {
    style: {
      "color": "#cccccc"
    }
  }, null, -1);
});

var _hoisted_5 = {
  class: "product_div"
};
var _hoisted_6 = {
  class: "product_item"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: "https://m.52haoma.com/images/broadband-icon/unicom_yxd.jpg"
  }, null, -1);
});

var _hoisted_8 = {
  class: "product_content"
};

var _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-1f8197c4>联通光宽带全国商机单-基地</div><div class=\"content\" data-v-1f8197c4><div data-v-1f8197c4><span class=\"value\" data-v-1f8197c4>100-1000 M</span><span class=\"name\" data-v-1f8197c4>带宽</span></div><div class=\"sep_v\" data-v-1f8197c4></div><div data-v-1f8197c4><span class=\"value\" data-v-1f8197c4>待定</span><span class=\"name\" data-v-1f8197c4>资费</span></div><div class=\"sep_v\" data-v-1f8197c4></div><div data-v-1f8197c4><span class=\"value\" data-v-1f8197c4>待定</span><span class=\"name\" data-v-1f8197c4>安装费</span></div><div class=\"sep_v\" data-v-1f8197c4></div><div data-v-1f8197c4><span class=\"value\" data-v-1f8197c4>全国</span><span class=\"name\" data-v-1f8197c4>地区</span></div></div>", 2);

var _hoisted_11 = {
  class: "product_item"
};
var _hoisted_12 = ["src"];
var _hoisted_13 = {
  class: "product_content"
};
var _hoisted_14 = {
  class: "title"
};
var _hoisted_15 = {
  class: "content"
};
var _hoisted_16 = {
  class: "value"
};

var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "name"
  }, "带宽", -1);
});

var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "sep_v"
  }, null, -1);
});

var _hoisted_19 = {
  class: "value"
};

var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "name"
  }, "资费", -1);
});

var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "sep_v"
  }, null, -1);
});

var _hoisted_22 = {
  class: "value"
};

var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "name"
  }, "安装费", -1);
});

var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "sep_v"
  }, null, -1);
});

var _hoisted_25 = {
  key: 0,
  class: "value"
};
var _hoisted_26 = {
  key: 1,
  class: "value"
};

var _hoisted_27 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "name"
  }, "地区", -1);
});

var _hoisted_28 = ["onClick"];

var _hoisted_29 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "height": "1rem"
    }
  }, null, -1);
});

var _hoisted_30 = {
  style: {
    "width": "7.5rem",
    "margin": "0 auto"
  }
};
var _hoisted_31 = {
  key: 1,
  class: "city_list"
};
var _hoisted_32 = {
  key: 2,
  class: "nodata"
};
var _hoisted_33 = {
  class: "order_div"
};
var _hoisted_34 = {
  class: "product_div"
};
var _hoisted_35 = {
  class: "product_item"
};
var _hoisted_36 = ["src"];
var _hoisted_37 = {
  class: "product_content"
};
var _hoisted_38 = {
  class: "title"
};
var _hoisted_39 = {
  class: "content"
};
var _hoisted_40 = {
  class: "value"
};

var _hoisted_41 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "name"
  }, "带宽", -1);
});

var _hoisted_42 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "sep_v"
  }, null, -1);
});

var _hoisted_43 = {
  class: "value"
};

var _hoisted_44 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "name"
  }, "资费", -1);
});

var _hoisted_45 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "sep_v"
  }, null, -1);
});

var _hoisted_46 = {
  class: "value"
};

var _hoisted_47 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "name"
  }, "安装费", -1);
});

var _hoisted_48 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "sep_v"
  }, null, -1);
});

var _hoisted_49 = {
  key: 0,
  class: "value"
};
var _hoisted_50 = {
  key: 1,
  class: "value"
};

var _hoisted_51 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "name"
  }, "地区", -1);
});

var _hoisted_52 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("hr", null, null, -1);
});

var _hoisted_53 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "order_info1"
  }, [/*#__PURE__*/_createElementVNode("span", {
    class: "red"
  }, "*"), /*#__PURE__*/_createTextVNode("请务必填写正确的安装信息"), /*#__PURE__*/_createElementVNode("span", {
    class: "red"
  }, "*")], -1);
});

var _hoisted_54 = /*#__PURE__*/_createTextVNode("上门收费");

var _hoisted_55 = /*#__PURE__*/_createTextVNode("前台收费");

var _hoisted_56 = /*#__PURE__*/_createTextVNode("扫码支付");

var _hoisted_57 = /*#__PURE__*/_createTextVNode(" 我已阅读并同意 ");

var _hoisted_58 = /*#__PURE__*/_createTextVNode("立即预约");

var _hoisted_59 = {
  class: "buy_know"
};

var _hoisted_60 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h4", null, "预约须知", -1);
});

var _hoisted_61 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "border": "0.01rem solid #ffffff"
    }
  }, null, -1);
});

var _hoisted_62 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("label", null, "1、", -1);
});

var _hoisted_63 = {
  key: 0
};
var _hoisted_64 = {
  key: 1
};
var _hoisted_65 = {
  key: 2
};
var _hoisted_66 = {
  key: 3
};

var _hoisted_67 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("label", null, "2、"), /*#__PURE__*/_createTextVNode("本页面为意向单预约页面，相关信息仅用作预约意向收集，不会直接为您办理业务，预约后将有工作人员与您联系沟通，实际办理情况请以工作人员与您确认的信息为准。")], -1);
});

var _hoisted_68 = {
  key: 0
};

var _hoisted_69 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "width": "7.5rem",
      "height": "2.0rem",
      "margin": "0 auto"
    }
  }, null, -1);
});

var _hoisted_70 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h3", {
    style: {
      "margin": "0.3rem",
      "font-size": "0.26rem",
      "text-align": "center"
    }
  }, "关于客户个人信息收集、使用规则的公告", -1);
});

var _hoisted_71 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    style: {
      "font-size": "0.2rem"
    }
  }, [/*#__PURE__*/_createTextVNode(" 尊敬的客户："), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 根据《中华人民共和国反恐怖主义法》、《全国人民代表大会常务委员会关于加强网络信息保护的决定》、《电信和互联网用户个人信息保护规定》 （工业和信息化部令第24号）和《电话用户真实身份信息登记规定》（工业和信息化部令第25号）等国家法律法规的要求，客户在运营商各类营业网点 （含自有营业厅、手机营业厅、网上营业厅、授权合作代理商等）办理固定电话、移动电话（含无线上网卡）入网、过户以 及需要出示客户证件的有关业务时，客户应配合出示有效证件原件并进行查验、登记，登记信息包括姓名、证件类型、号码及地址等。同时，为更好 地提供服务，需要客户提供如联系人、联系电话、通信地址、电子邮箱等信息。客户本人持有效证件可通过自有营业厅查询和/或更正本人信息，或登 录手机营业厅查询本人信息。"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 如客户拒绝依法提供个人有效证件及真实信息，我公司有权不提供服务或终止服务。"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 为向客户提供优质、个性化的服务，包括但不限于提供通信服务、保障通信服务安全、改善服务质量、 推介个性化产品等，我公司将遵循合法、正当、必要的原则，按照法律法规规定和/或协议约定使用留存客 户个人信息，并妥善保管，严格保密，依法保护客户个人信息，非因下列事由，不对外泄露客户个人信息:"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" (a)事先获得客户的明确授权；"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" (b)根据有关的法律法规要求；"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" (c)按照相关司法机关和/或政府主管部门的要求；"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" (d)为维护社会公众的利益所必需且适当；"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" (e)为维护我公司或客户的合法权益所必需且适当。"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("br")], -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_icon = _resolveComponent("van-icon");

  var _component_van_search = _resolveComponent("van-search");

  var _component_van_cell = _resolveComponent("van-cell");

  var _component_van_picker = _resolveComponent("van-picker");

  var _component_van_popup = _resolveComponent("van-popup");

  var _component_van_nav_bar = _resolveComponent("van-nav-bar");

  var _component_van_field = _resolveComponent("van-field");

  var _component_van_radio = _resolveComponent("van-radio");

  var _component_van_radio_group = _resolveComponent("van-radio-group");

  var _component_van_checkbox = _resolveComponent("van-checkbox");

  var _component_van_cell_group = _resolveComponent("van-cell-group");

  var _component_van_button = _resolveComponent("van-button");

  var _component_van_form = _resolveComponent("van-form");

  var _component_van_image = _resolveComponent("van-image");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "phoneBelong",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $data.ascriptionShow = true;
    })
  }, [_createVNode(_component_van_icon, {
    name: "location-o",
    style: {
      "width": "0.4rem"
    }
  }), _createElementVNode("label", null, [_hoisted_3, _createTextVNode(" " + _toDisplayString($data.queryObj.province) + " " + _toDisplayString($data.queryObj.city), 1)]), _createVNode(_component_van_icon, {
    name: "arrow-down",
    style: {
      "width": "0.4rem"
    }
  })]), _createElementVNode("div", {
    class: "phoneBelong",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $data.optShow = true;
    })
  }, [_createVNode(_component_van_icon, {
    name: "wap-home-o",
    style: {
      "width": "0.4rem"
    }
  }), _createElementVNode("label", null, [_hoisted_4, _createTextVNode(" " + _toDisplayString($data.optName), 1)]), _createVNode(_component_van_icon, {
    name: "arrow-down",
    style: {
      "width": "0.4rem"
    }
  })])]), $data.ipLocationTip ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "ip_tip",
    onClick: _cache[2] || (_cache[2] = function () {
      return $options.switchToLocatedCity && $options.switchToLocatedCity.apply($options, arguments);
    })
  }, [_createVNode(_component_van_icon, {
    name: "aim"
  }), _createElementVNode("span", null, _toDisplayString($data.ipLocationTip), 1), _createVNode(_component_van_icon, {
    name: "arrow"
  })])) : _createCommentVNode("", true), _createElementVNode("div", null, [_createElementVNode("a", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", {
    class: "btn_div",
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return $options.bookInstall({
        'id': -1,
        'iconName': 'unicom_yxd.jpg',
        'productName': '联通光宽带全国商机单-基地',
        'productOptId': 2,
        'userProductName': '联通光宽带全国商机单-基地',
        'bandwidth': '100-1000',
        'price': '待定',
        'installPrice': '待定',
        'city': '全国'
      });
    })
  }, "预约安装")])])]), _createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.broadbandProductList, function (item, index) {
    return _openBlock(), _createElementBlock("a", {
      class: "product_div",
      key: 'products_' + index
    }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
      src: 'https://m.52haoma.com/images/broadband-icon/' + item.iconName
    }, null, 8, _hoisted_12), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(item.productName), 1), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_16, _toDisplayString(item.bandwidth) + " M", 1), _hoisted_17]), _hoisted_18, _createElementVNode("div", null, [_createElementVNode("span", _hoisted_19, _toDisplayString(item.price), 1), _hoisted_20]), _hoisted_21, _createElementVNode("div", null, [_createElementVNode("span", _hoisted_22, _toDisplayString(item.installPrice) + " 元", 1), _hoisted_23]), _hoisted_24, _createElementVNode("div", null, [item.city != null && item.city != '' ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(item.city), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(item.province), 1)), _hoisted_27])]), _createElementVNode("div", {
      class: "btn_div",
      onClick: function onClick($event) {
        return $options.bookInstall(item);
      }
    }, "预约安装", 8, _hoisted_28)])])]);
  }), 128))]), _hoisted_29]), _createVNode(_component_van_popup, {
    show: $data.ascriptionShow,
    "onUpdate:show": _cache[8] || (_cache[8] = function ($event) {
      return $data.ascriptionShow = $event;
    }),
    round: "",
    position: "bottom"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_30, [_createVNode(_component_van_search, {
        modelValue: $data.cityKeyword,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return $data.cityKeyword = $event;
        }),
        placeholder: "手工输入城市名称，如：杭州",
        onSearch: $options.confirmCityKeyword
      }, null, 8, ["modelValue", "onSearch"]), !$data.cityKeyword ? (_openBlock(), _createBlock(_component_van_cell, {
        key: 0,
        clickable: "",
        icon: "aim",
        title: "定位当前城市",
        loading: $data.locating,
        onClick: _cache[5] || (_cache[5] = function ($event) {
          return $options.locateByIp(false);
        })
      }, null, 8, ["loading"])) : _createCommentVNode("", true), $options.matchedCityList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.matchedCityList, function (item, index) {
        return _openBlock(), _createBlock(_component_van_cell, {
          key: 'city_search_' + index,
          clickable: "",
          icon: "location-o",
          title: item.province + '  ' + item.city,
          onClick: function onClick($event) {
            return $options.selectCity(item);
          }
        }, null, 8, ["title", "onClick"]);
      }), 128))])) : $data.cityKeyword ? (_openBlock(), _createElementBlock("div", _hoisted_32, " 没有找到匹配的城市，请重新输入或从下方选择 ")) : _createCommentVNode("", true), _withDirectives(_createVNode(_component_van_picker, {
        style: {
          "width": "7.5rem",
          "margin": "0rem auto"
        },
        modelValue: $data.areaCode,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
          return $data.areaCode = $event;
        }),
        title: "请选择您所在的城市",
        columns: $data.ascription,
        onCancel: _cache[7] || (_cache[7] = function ($event) {
          return $data.ascriptionShow = false;
        }),
        onConfirm: $options.confirmAscription
      }, null, 8, ["modelValue", "columns", "onConfirm"]), [[_vShow, !$data.cityKeyword]])])];
    }),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $data.optShow,
    "onUpdate:show": _cache[10] || (_cache[10] = function ($event) {
      return $data.optShow = $event;
    }),
    round: "",
    position: "bottom"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_picker, {
        style: {
          "width": "7.5rem",
          "margin": "0rem auto"
        },
        title: "请选择运营商",
        columns: $data.opts,
        onCancel: _cache[9] || (_cache[9] = function ($event) {
          return $data.optShow = false;
        }),
        onConfirm: $options.confirmOpt
      }, null, 8, ["columns", "onConfirm"])];
    }),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $data.show,
    "onUpdate:show": _cache[23] || (_cache[23] = function ($event) {
      return $data.show = $event;
    }),
    position: "bottom",
    style: {
      "height": "100%"
    }
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_nav_bar, {
        "left-arrow": "",
        "left-text": "返回",
        style: {
          "width": "7.5rem",
          "margin": "0 auto"
        },
        title: "预约安装",
        onClickLeft: _cache[11] || (_cache[11] = function ($event) {
          return $data.show = false;
        })
      }), _createElementVNode("div", _hoisted_33, [_createElementVNode("a", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createElementVNode("img", {
        src: 'https://m.52haoma.com/images/broadband-icon/' + $data.selectedProduct.iconName
      }, null, 8, _hoisted_36), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, _toDisplayString($data.selectedProduct.productName), 1), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_40, _toDisplayString($data.selectedProduct.bandwidth) + " M", 1), _hoisted_41]), _hoisted_42, _createElementVNode("div", null, [_createElementVNode("span", _hoisted_43, _toDisplayString($data.selectedProduct.price), 1), _hoisted_44]), _hoisted_45, _createElementVNode("div", null, [_createElementVNode("span", _hoisted_46, _toDisplayString($data.selectedProduct.installPrice) + " 元", 1), _hoisted_47]), _hoisted_48, _createElementVNode("div", null, [$data.selectedProduct.city != null && $data.selectedProduct.city != '' ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString($data.selectedProduct.city), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString($data.selectedProduct.province), 1)), _hoisted_51])])])])]), _hoisted_52, _hoisted_53, _createVNode(_component_van_form, {
        onSubmit: $options.submitBookingOrder
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_cell_group, {
            inset: ""
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_van_field, {
                modelValue: $data.addressCast,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) {
                  return $data.addressCast = $event;
                }),
                rows: 2,
                placeholder: "例如：13258888888 张三332624198411214622浙江杭州市拱墅区兴业街16号6幢422",
                type: "textarea",
                onChange: _cache[13] || (_cache[13] = function ($event) {
                  return $options.chgInfo();
                }),
                style: {
                  "margin-bottom": "10px",
                  "border": "1px solid #cccccc"
                }
              }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
                modelValue: $data.broadbandOrder.userInfo.userName,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = function ($event) {
                  return $data.broadbandOrder.userInfo.userName = $event;
                }),
                rules: [{
                  required: true,
                  message: '请正确填写真实姓名',
                  validator: $options.nameValidator
                }],
                label: "真实姓名",
                name: "姓名",
                placeholder: "请输入开户人真实姓名",
                required: ""
              }, null, 8, ["modelValue", "rules"]), _createVNode(_component_van_field, {
                modelValue: $data.broadbandOrder.userInfo.idCard,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = function ($event) {
                  return $data.broadbandOrder.userInfo.idCard = $event;
                }),
                rules: [{
                  required: true,
                  message: '请正确填写身份证号',
                  validator: $options.idCardValidator
                }],
                label: "身份证号",
                name: "身份证号",
                placeholder: "请输入开户人真实身份证",
                required: ""
              }, null, 8, ["modelValue", "rules"]), _createVNode(_component_van_field, {
                modelValue: $data.areaStr,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = function ($event) {
                  return $data.areaStr = $event;
                }),
                "is-link": "",
                options: $data.unicomAddressAuto,
                label: "安装地址",
                name: "安装地址",
                placeholder: "请选择安装宽带的省 / 城市 / 区县",
                readonly: "",
                onClick: _cache[17] || (_cache[17] = function ($event) {
                  return $data.addressShow = true;
                }),
                rules: [{
                  required: true,
                  message: '请选择安装宽带的省/城市/区县信息'
                }]
              }, null, 8, ["modelValue", "options"]), _createVNode(_component_van_field, {
                modelValue: $data.broadbandOrder.userInfo.address,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = function ($event) {
                  return $data.broadbandOrder.userInfo.address = $event;
                }),
                rules: [{
                  required: true,
                  message: '请输入正确的详细地址'
                }],
                label: "详细地址",
                name: "详细地址",
                placeholder: "请输入具体到门牌号详细地址",
                required: ""
              }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
                modelValue: $data.broadbandOrder.userInfo.phone,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = function ($event) {
                  return $data.broadbandOrder.userInfo.phone = $event;
                }),
                rules: [{
                  required: true,
                  message: '请正确填写联系电话',
                  validator: $options.phoneValidator
                }],
                label: "联系电话",
                name: "联系电话",
                placeholder: "请输入开户人真实联系电话",
                required: "",
                type: "tel"
              }, null, 8, ["modelValue", "rules"]), _createVNode(_component_van_field, {
                name: "radio",
                label: "付费类型"
              }, {
                input: _withCtx(function () {
                  return [_createVNode(_component_van_radio_group, {
                    modelValue: $data.broadbandOrder.payFlag,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = function ($event) {
                      return $data.broadbandOrder.payFlag = $event;
                    }),
                    direction: "horizontal"
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_van_radio, {
                        name: 0
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_54];
                        }),
                        _: 1
                      }), _createVNode(_component_van_radio, {
                        name: 1
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_55];
                        }),
                        _: 1
                      }), _createVNode(_component_van_radio, {
                        name: 2
                      }, {
                        default: _withCtx(function () {
                          return [_hoisted_56];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_van_field, {
                rules: [{
                  required: true,
                  message: '请阅读并勾选'
                }],
                name: "checkbox"
              }, {
                input: _withCtx(function () {
                  return [_createVNode(_component_van_checkbox, {
                    modelValue: $data.checked,
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = function ($event) {
                      return $data.checked = $event;
                    }),
                    shape: "square"
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_57, _createElementVNode("span", {
                        class: "blue",
                        onClick: _cache[21] || (_cache[21] = function ($event) {
                          return $data.infoAdvise = true;
                        })
                      }, "《关于客户个人信息收集、使用及保护的公告》")];
                    }),
                    _: 1
                  }, 8, ["modelValue"])];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode(_component_van_button, {
            class: "pay_btn",
            "native-type": "submit",
            disabled: $data.submitBtnFlag
          }, {
            default: _withCtx(function () {
              return [_hoisted_58];
            }),
            _: 1
          }, 8, ["disabled"])];
        }),
        _: 1
      }, 8, ["onSubmit"]), _createElementVNode("div", _hoisted_59, [_hoisted_60, _hoisted_61, _createElementVNode("div", null, [_createElementVNode("p", null, [_hoisted_62, _createTextVNode("您预约安装的是" + _toDisplayString($data.selectedProduct.province) + _toDisplayString($data.selectedProduct.city) + " ", 1), $data.selectedProduct.productOptId == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_63, "移动")) : $data.selectedProduct.productOptId == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_64, "联通")) : $data.selectedProduct.productOptId == 3 ? (_openBlock(), _createElementBlock("span", _hoisted_65, "电信")) : $data.selectedProduct.productOptId == 5 ? (_openBlock(), _createElementBlock("span", _hoisted_66, "广电")) : _createCommentVNode("", true), _createTextVNode(" 的" + _toDisplayString($data.selectedProduct.bandwidth) + "M宽带" + _toDisplayString($data.selectedProduct.price) + "，初装费" + _toDisplayString($data.selectedProduct.installPrice) + "元。", 1)]), _hoisted_67])]), _createElementVNode("div", null, [$data.selectedProduct.productOptId == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_68, [$data.selectedProduct.province == '安徽' ? (_openBlock(), _createBlock(_component_van_image, {
        key: 0,
        src: require('@/assets/images/anhui_unicom_bsp.png')
      }, null, 8, ["src"])) : $data.selectedProduct.province == '浙江' ? (_openBlock(), _createBlock(_component_van_image, {
        key: 1,
        src: require('@/assets/images/zhejiang_unicom_bsp.png')
      }, null, 8, ["src"])) : $data.selectedProduct.province == '湖北' ? (_openBlock(), _createBlock(_component_van_image, {
        key: 2,
        src: require('@/assets/images/hubei_unicom_bsp.png')
      }, null, 8, ["src"])) : (_openBlock(), _createBlock(_component_van_image, {
        key: 3,
        src: require('@/assets/images/changsha_jd_unicom_bsp.png')
      }, null, 8, ["src"]))])) : $data.selectedProduct.productOptId == 3 ? (_openBlock(), _createBlock(_component_van_image, {
        key: 1,
        src: require('../../assets/images/telcom_bsp.png')
      }, null, 8, ["src"])) : $data.selectedProduct.productOptId == 5 ? (_openBlock(), _createBlock(_component_van_image, {
        key: 2,
        src: require('../../assets/images/broadnet_bsp.png')
      }, null, 8, ["src"])) : _createCommentVNode("", true)]), _hoisted_69])];
    }),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $data.addressShow,
    "onUpdate:show": _cache[25] || (_cache[25] = function ($event) {
      return $data.addressShow = $event;
    }),
    position: "bottom",
    round: ""
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_picker, {
        style: {
          "width": "7.5rem",
          "margin": "0 auto"
        },
        title: "请选择宽带安装的 省 / 市 / 区县",
        columns: $data.unicomAddress,
        onCancel: _cache[24] || (_cache[24] = function ($event) {
          return $data.addressShow = false;
        }),
        onConfirm: $options.confirmAddress
      }, null, 8, ["columns", "onConfirm"])];
    }),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $data.infoAdvise,
    "onUpdate:show": _cache[26] || (_cache[26] = function ($event) {
      return $data.infoAdvise = $event;
    }),
    closeable: "",
    style: {
      "width": "6.8rem",
      "padding": "0.3rem",
      "margin": "0 auto"
    }
  }, {
    default: _withCtx(function () {
      return [_hoisted_70, _hoisted_71];
    }),
    _: 1
  }, 8, ["show"])]);
}